var common = require("../../utiles/common");
var metaService = require("../../services/metaService")
var layUtils = require("../../utiles/layUtils");
var metaTypeUtils = require("../../utiles/metaTypeUtils")

module.exports = {
    register: function () {
        document.createElement('link-to')
        ko.components.register('link-to', {
            viewModel: function (params) {
                var $this = this;
                $this.params = params.app;
                $this.code = $this.params.code;
                $this.name = $this.params.name;
                $this.verify = params.verify;
                $this.options = ko.observableArray($this.params.options);
                $this.fieldName = $this.params.fieldName;
                $this.activeValue = ko.observable();
                $this.verify = $this.params.rules?$this.params.rules.join("|"):"";
                $(document).mouseup(function(e){
                    var _con = $(".form-linkTo");
                    if(!_con.is(e.target) && _con.has(e.target).length === 0){
                        $this.removeClass();
                    }
                });
                $this.setValue = function(item){
                    $("#"+$this.fieldName).val(item[$this.name]);
                    $("#"+$this.fieldName).attr("data-val",item[$this.code]);
                    $this.activeValue(item[$this.code]);
                    $this.removeClass();
                }
                layui.use(['form', 'layedit','upload'], function () {
                    var form = layui.form
                    $this.addClass = function(){
                        $("#form-linkTo-"+$this.fieldName).addClass("form-linkTo-selected");
                    }
                    $this.removeClass = function(){
                        $("#form-linkTo-"+$this.fieldName).removeClass("form-linkTo-selected");
                    }
                    var lastFetchId = 0;
                    $this.search = function () {
                        var value = $("#"+$this.fieldName).val();
                        ++lastFetchId;
                        var fetchId = lastFetchId;
                        setTimeout(function(){
                            if(fetchId === lastFetchId){
                                var options = metaService.queryDataByContains({
                                    condition: {displayName: value},
                                    size:20,
                                    dataTypeQualifyName: $this.params.dataTypeId
                                })
                                $this.options(options.result);
                                console.log($this.options())
                                form.render();
                            }
                        },200);
                    }
                    $this.search();
                });
            },
            template: require("./LinkTo.html")
        });
        document.createElement('upload-image')
        ko.components.register('upload-image', {
            viewModel: function (params) {
                var $this = this;
                $this.fieldName = params.app.fieldName;
                console.log(params)
                layui.use('upload', function(){
                    var upload = layui.upload;
                    //执行实例
                    setTimeout(function(){
                        var uploadInst = upload.render({
                            elem: "#"+$this.fieldName,
                            url: '/auth/uploadFile/upload',
                            acceptMime:"image/*",
                            done: function(res){
                                console.log(res)
                                $("#"+$this.fieldName).attr("data-val",res.data);
                            },
                            error: function(){
                            }
                        });
                    },1)
                });
            },
            template: require("./UploadImage.html")
        });
        document.createElement('upload-file')
        ko.components.register('upload-file', {
            viewModel: function (params) {
                var $this = this;
                $this.fieldName = params.app.fieldName;
                layui.use('upload', function(){
                    var upload = layui.upload;
                    //执行实例
                    setTimeout(function(){
                        var uploadInst = upload.render({
                            elem: "#"+$this.fieldName,
                            url: '/auth/uploadFile/upload',
                            accept:"file",
                            done: function(res){
                                console.log(res)
                                $("#"+$this.fieldName).attr("data-val",res.data);
                            },
                            error: function(){
                            }
                        });
                    },1)
                });
            },
            template: require("./UploadFile.html")
        });
        document.createElement('sms-verify')
        ko.components.register('sms-verify', {
            viewModel: function (params) {
                var $this = this;
                var times = 60;
                $this.verify = params.verify;
                $this.fieldName = params.app.fieldName;
                $this.smsVerifyConfig = params.app.smsVerifyConfig;
                $this.noteNone = ko.observable(false);
                $this.codeMsg = ko.observable(commonLocal.app.SendCode);
                $this.config = metaService.findOne({
                    dataTypeQualifyName:metaTypeUtils.metaType.QNAME_NOTIFY_SMSVERIFYCONFIG,
                    condition:{id:$this.smsVerifyConfig}
                })
                console.log($this.config)
                $this.getTime = function(){
                    var time=setInterval(function(){
                        if(times != 0){
                            times--;
                            $this.codeMsg(times+"s")
                        }else{
                            $this.codeMsg(commonLocal.app.SendAgain);
                            $this.noteNone(false);
                            clearInterval(time);
                        }
                    },1000);
                }
                $this.getCode = function(){
                    if($this.noteNone())return false;
                    var phoneAttribute = $this.config?$this.config.phoneAttribute:"";
                    var phone=$("input[name="+phoneAttribute+"]").val();
                    console.log(phone)
                    if(/^1\d{10}$/.test(phone)&&!$this.noteNone()){
                        common.fetch("/auth/reg/sendSms", {
                            type: "GET", query: {phone:phone},
                            handleError: function (data) {
                            },
                            success: function (result) {
                                $this.noteNone(true);
                                $this.getTime();
                                layUtils.msg("发送成功!");
                            }
                        })
                    }else{
                        layUtils.msg(commonLocal.describe.IncorrectFormatOfMobilePhoneNumber);
                    }
                }

            },
            template: require("./SmsVerify.html")
        });
        document.createElement('img-verify')
        ko.components.register('img-verify', {
            viewModel: function (params) {
                var $this = this;
                $this.verify = params.verify;
                $this.fieldName = params.app.fieldName;
                $this.src = ko.observable();
                //获取验证
                $this.getVerify = function(){
                    var verifyType = params.verifyType?params.verifyType:"REG";
                    return "/auth/verification/img?type="+verifyType+"&random=" + Math.random()
                }
                $this.reloadVerifyCode = function(){
                    $this.src($this.getVerify());
                }
                $this.reloadVerifyCode();
            },
            template: require("./ImgVerify.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/template/form/ExtendForm.js
// module id = 73
// module chunks = 0